export interface ServiceStatus {
  name: string
  url: string
  healthy: boolean
  label: string
}

export async function checkHealth(name: string, url: string, label: string): Promise<ServiceStatus> {
  try {
    const res = await fetch(`${url}/health`, { signal: AbortSignal.timeout(3000) })
    return { name, url, label, healthy: res.ok }
  } catch {
    return { name, url, label, healthy: false }
  }
}

export async function checkAllServices(urls: Record<string, string>): Promise<ServiceStatus[]> {
  const entries: [string, string, string][] = [
    ['daemon',   urls.daemon   ?? '', 'DAEMON'],
    ['conclave', urls.conclave ?? '', 'Conclave'],
    ['assay',    urls.assay    ?? '', 'Assay'],
    ['lore',     urls.lore     ?? '', 'Lore'],
    ['gateway',  urls.gateway  ?? '', 'Gateway'],
  ]
  return Promise.all(entries.map(([name, url, label]) => checkHealth(name, url, label)))
}
